import { createContext } from 'react';
const MenuContext = createContext({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
});
export default MenuContext;
